import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppShell from "../layout/AppShell";
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import CallsPage from "../pages/CallsPage";
import AnalyticsPage from "../pages/AnalyticsPage";
import LeadManagementPage from "../pages/LeadManagementPage";
import AppointmentsPage from "../pages/AppointmentsPage";
import CampaignsPage from "../pages/CampaignsPage";
import TeamManagementPage from "../pages/TeamManagementPage";
import SettingsPage from "../pages/SettingsPage";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

function RootRedirect() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={`/dashboard${location.search || ""}`} replace />;
  }

  return <Navigate to="/login" replace />;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route element={<ProtectedRoute pageId="dashboard" />}>
            <Route path="/dashboard" element={<DashboardPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="calls" />}>
            <Route path="/calls" element={<CallsPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="analytics" />}>
            <Route path="/analytics" element={<AnalyticsPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="lead-management" />}>
            <Route path="/lead-management" element={<LeadManagementPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="appointments" />}>
            <Route path="/appointments" element={<AppointmentsPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="campaigns" />}>
            <Route path="/campaigns" element={<CampaignsPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="team-management" />}>
            <Route path="/team-management" element={<TeamManagementPage />} />
          </Route>
          <Route element={<ProtectedRoute pageId="settings" />}>
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}
